/* eslint-disable */
import { useState } from 'react';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Box, Button, Typography, IconButton, Tooltip } from '@mui/material';
import styles from './MyDeaprtmentPage.module.scss';
import { BackdropLoader } from '../../../Components/Loaders';
import VariantTable from '../../Food Products/VariantPrice/VariantTable';
import ImageModal from '../../../Components/Modals/ImageModal/ImageModal';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import { modalActions } from '../../../Actions';
import { Pencil, Eye } from 'lucide-react';
import departmentServices from '../../../Services/DepartmentServices/departmentServices';
import { useAuth } from '@/Components/Auth/Login/auth';

const VARIANT_COLUMNS = [
	{ key: 'id', title: 'ID', width: 100 },
	{ key: 'userRole', title: 'Department Name', width: 400 },
	{ key: 'actions', title: 'Actions', width: 150 },
];

function MyDeaprtmentPage({ createPath }) {
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(false);
	const [departmentsData, setDepartmentsData] = useState([]);
	const { userConfig = {} } = useAuth();
	const { userRolesDict = {} } = userConfig;
	const isInternal = Object.values(userRolesDict ?? {}).some(
		(v) => v?.toLowerCase() === 'internal'
	);
	const { level } = userConfig?.userDetails || {};

	const handleListFetch = async () => {
		setIsLoading(true);
		try {
			const response = await departmentServices.fetchDepartmentsList();
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				setDepartmentsData(response?.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleClick = (deptId, role, isView = false) => {
		const baseUrl = `${createPath}?id=${deptId}&userRole=${role}`;
		const finalUrl = isView ? `${baseUrl}&isView=true` : `${baseUrl}&isEdit=true`;
		history.push(finalUrl);
	};

	const customRowData = {
		id: (obj) => (
			<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
				{obj?.id ?? '-'}
			</div>
		),
		userRole: (obj) => (
			<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
				{obj?.userRole ?? '-'}
			</div>
		),
		actions: (obj) => (
			<div style={{ display: 'flex', justifyContent: 'center', width: '100%', gap: 8 }}>
				<Tooltip title='View Department'>
					<IconButton
						size='small'
						onClick={() => handleClick(obj?.id, obj?.userRole, true)}
						sx={{
							background: '#eff6ff',
							'&:hover': { background: '#dbeafe' },
							color: '#3554c6ff',
							borderRadius: 1.5,
							p: 0.8,
						}}
					>
						<Eye size={16} />
					</IconButton>
				</Tooltip>
				{(level > 2 || isInternal) && (
					<>
						<Tooltip title='Edit Department'>
							<IconButton
								size='small'
								onClick={() => handleClick(obj?.id, obj?.userRole)}
								sx={{
									background: '#facc15',
									'&:hover': { background: '#eab308' },
									color: '#000',
									borderRadius: 1.5,
									p: 0.8,
								}}
							>
								<Pencil size={16} />
							</IconButton>
						</Tooltip>
					</>
				)}
			</div>
		),
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={isLoading} />
			<ImageModal />
			<div className={styles.header}>
				<ImagesFinder
					pageLabel='My Departments'
					FILTERS={[]}
					onSubmit={handleListFetch}
					additionInfo={{
						showAdd: true,
						addText: 'Department',
						handleAddClick,
					}}
				/>
			</div>
			<Box sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				p: 2,
				flexShrink: 0
			}}>
				<Typography variant='h6'>My Departments List</Typography>
				{(level > 2 || isInternal) && (
					<Button
						onClick={handleAddClick}
						sx={{
							backgroundColor: '#facc15',
							'&:hover': { backgroundColor: '#eab308' },
							color: 'black',
							textTransform: 'none',
							fontWeight: 500,
							borderRadius: 1.5,
							px: 3,
						}}
					>
						+ New Department
					</Button>
				)}
			</Box>
			<div className='h-[calc(100vh-250px)]'>
				<VariantTable
					columns={VARIANT_COLUMNS}
					data={departmentsData}
					customRowData={customRowData}
					isLoading={isLoading}
				/>
			</div>
		</div>
	);
}

export default MyDeaprtmentPage;
